module.exports = __webpack_public_path__ + "static/media/influence-edition-2025-social-image.ea8e849f.jpg";